module.exports = __webpack_public_path__ + "img/tall.be5030ca.webp";